import { invitedSupplierI, SupplierI, taskProps, tenderDataProps } from '../../../pages/TenderViewPage/types';
import {
    collectInvitedSupplierEmails,
    collectTenderSupplierEmails,
    copyEmailsToClipboard
} from '../../../utils/copySupplierEmails';
import { FC, useRef, useEffect, useState, ChangeEvent } from 'react';
import plus from '../../../assets/Plus, Add.svg';
import copyImage from '../../../assets/copyImage.svg';
import SupplierListIcon from '../../../assets/SupplierListIcon.svg';
import userProfileTaskIcon from '../../../assets/User,Profile.svg';
import { Button, Divider, message, Modal, Radio, Switch, Tooltip } from 'antd';
import i from '../../../assets/i.svg';
import stopImage from '../../../assets/stopImage.svg';
import done from '../../../assets/Done, Check.svg';
import messageIcon from '../../../assets/chat-message.svg';
import { AwardSuppliserModal } from '../../Modals/AwardSuppliserModal';
import download from '../../../assets/download.svg';
import attention from '../../../assets/attention.svg';
import email from '../../../assets/mail.svg';
import phone from '../../../assets/Phone.svg';
import incumbent from '../../../assets/incumbent.svg';
import notIncumbent from '../../../assets/not-incumbent.svg';

import attantion from '../../../assets/point.svg';
import arrow from '../../../assets/arrow.svg';

import Visit from '../../../assets/Visit.svg';
import NotProvided from '../../../assets/Not Provided.svg';
import Requested from '../../../assets/Requested.svg';
import Received from '../../../assets/Received.svg';
import {
    useDeleteSupplierAwardMutation,
    useDeleteSupplierInviteMutation,
    useResendInvitesToSuppliersMutation,
    useResendInviteSupplierCompaniesMutation,
    useShortlistSupplierMutation,
    useUpdateGradeMutation,
    useUpdateIncumbentInTenderMutation,
    useUpdateIncumbentMutation
} from '../../../api/tenders';
import { Loader } from '../../Loader/Loader';
import { AddSuppliersModal } from '../../Modals/AddSuppliersModal';
import Confirmed from '../../../assets/Confirmed.svg';
import Unconfirmed from '../../../assets/Unconfirmed.svg';
import deleteIcon from '../../../assets/DeleteIcon.svg';
import Unverified from '../../../assets/Unverified.svg';
import Verified from '../../../assets/Verified.svg';
import editIcon from '../../../assets/editAdminIcon.svg';
import { AddSupplierModal } from '../../Modals/AddSupplierModal';
import { EditSupplierModal } from '../../Modals/EditSupplierModal';
import { AddConfirmedSuppliersModal } from '../../Modals/AddConfirmedSuppliersModal';
import { useDeleteSupplierMutation } from '../../../api/tenders';
import pendingIcon from '../../../assets/panding-circle.svg';
import { RejectSupplierModal } from '../../Modals/RejectSupplierModal';
import { RejectIncumbentSupplier } from '../../Modals/RejectIncumbentSupplier';
import { useClickOutside } from '../../../hooks/useClickOutSide';
import {
    downloadBidConditions,
    downloadCapabilityProfile,
    downloadMatchmakingReportPdf,
    downloadProfileSummary,
    downloadSingleFileFunc,
    downloadSolutionGuide
} from '../../../api/axiosCruds';
import { ScoreHistory } from '../components/ScoreHistory';
import { AgreementLinkModal } from '../../Modals/AgreementLinkModal';
import { capitalize, ViewSupplierListModal } from './ViewSupplierListModal';
import { IncumbentModal } from '../../Modals/IncumbentModal';
import Edit from '../../Icons/Edit';
import { SupplierCardEvaluate1 } from './SupplierCardEvaluate1.tsx';
import { SupplierCardForTR } from './SupplierCardForTR.tsx';
import { SupplierEvaluate2SU } from './SupplierEvaluate2SU.tsx';
import { SupplierCardForTREvaluate2 } from './SupplierCardForTREvaluate2.tsx';
import { RejectSupplierModalOnEvaluate2 } from '../../Modals/RejectSupplierModalOnEvaluate2';
import { Evaluate4PendingTRSuppliersTaskComplete } from './Evaluate4PendingTRSuppliersTaskComplete';
import { SupplierPriceInformationModal } from '../../Modals/SupplierPriceInformationModal';
import { SupplierCardEvaluate3SU } from '../EvaluatePhase4Components/SupplierCardEvaluate3SU';

interface DefineSupportingDocumentTaskProps {
    data: tenderDataProps;
    role: string | null;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    messageApi: any;
}

const phaseTaskDocumentLinks = (task: taskProps) =>
    (task.document_links ?? []).filter((d) => String(d.link || d.url || '').trim().length > 0);

const star = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
                d="M3.86361 10.4163C3.61007 10.5486 3.30335 10.5253 3.07271 10.3562C2.84208 10.1871 2.72765 9.90153 2.77765 9.61994L3.18232 7.30047L1.47861 5.66779C1.27036 5.46919 1.19404 5.16899 1.28216 4.89505C1.37028 4.62111 1.60731 4.4217 1.89228 4.38175L4.25777 4.04361L5.32571 1.91323C5.45234 1.65773 5.71284 1.49609 5.99799 1.49609C6.28315 1.49609 6.54365 1.65773 6.67027 1.91323L7.73822 4.04361L10.1037 4.38175C10.3887 4.4217 10.6257 4.62111 10.7138 4.89505C10.8019 5.16899 10.7256 5.46919 10.5174 5.66779L8.81367 7.30047L9.21834 9.62044C9.26834 9.90203 9.15391 10.1876 8.92328 10.3567C8.69264 10.5258 8.38592 10.5491 8.13238 10.4168L5.99799 9.31381L3.86361 10.4163Z"
                fill="#E3A11F"
                stroke="#E3A11F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

const ServiceSpecTruncatedLabel: FC<{ label: string }> = ({ label }) => {
    const ref = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    const measure = () => {
        const el = ref.current;
        if (!el) return;
        setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    useEffect(() => {
        const id = requestAnimationFrame(measure);
        return () => cancelAnimationFrame(id);
    }, [label]);

    return (
        <div className="service-spec__item-label-wrap">
            <Tooltip title={isTruncated ? label : undefined} mouseEnterDelay={0.35}>
                <span ref={ref} className="service-spec__item-label" onMouseEnter={measure}>
                    {label}
                </span>
            </Tooltip>
        </div>
    );
};

const getPricingBreakdownFileMeta = (data: tenderDataProps | undefined): { uuid?: string; name?: string } => {
    const task = data?.phase_tasks?.find((p) => p.action === 'evaluate_4_suppliers');
    const pf = task?.pricing_file;
    if (pf == null) return {};
    if (typeof pf === 'string') {
        const s = pf.trim();
        return s ? { uuid: s } : {};
    }
    const uuid = pf.uuid?.trim();
    const name = typeof pf.name === 'string' ? pf.name.trim() : undefined;
    return {
        ...(uuid ? { uuid } : {}),
        ...(name ? { name } : {})
    };
};

function fileNameFromContentDisposition(headers: Record<string, unknown>): string | undefined {
    const cd = headers['content-disposition'] ?? headers['Content-Disposition'];
    if (typeof cd !== 'string' || !cd.trim()) return undefined;
    const utf8 = cd.match(/filename\*=UTF-8''([^;\n]+)/i);
    if (utf8?.[1]) {
        try {
            return decodeURIComponent(utf8[1].trim().replace(/^["']|["']$/g, ''));
        } catch {
            /* ignore */
        }
    }
    const quoted = cd.match(/filename="([^"]*)"/i);
    if (quoted?.[1]) return quoted[1].trim();
    const simple = cd.match(/filename=([^;\n]+)/i);
    if (simple?.[1]) return simple[1].trim().replace(/^["']|["']$/g, '');
    return undefined;
}

function saveBlobResponseAsDownload(
    response: { data: Blob; headers: Record<string, unknown> },
    fallbackBaseName: string
): void {
    const fromHeader = fileNameFromContentDisposition(response.headers);
    let filename = (fromHeader || fallbackBaseName || 'download').replace(/"/g, '').trim();
    if (!filename) filename = 'download';
    const blob = new Blob([response.data], {
        type: (response.headers['content-type'] as string) || 'application/octet-stream'
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

/** All suppliers resolved (excluded or evaluation complete) — green border on Evaluate 4 task card */
const allEvaluate4SuppliersStatusesFinal = (data: tenderDataProps | undefined): boolean => {
    const suppliers = data?.suppliers ?? [];
    return suppliers.length > 0 && suppliers.every((s) => s.status === 'rejected' || s.status === 'shortlisted');
};

const Evaluate4SuDownloadsMenu: FC<{
    tenderId?: number;
    pricingBreakdownFileUuid?: string | null;
    /** From task `pricing_file.name` — used as download filename when headers omit it */
    pricingBreakdownFileName?: string | null;
}> = ({ tenderId, pricingBreakdownFileUuid, pricingBreakdownFileName }) => {
    const [open, setOpen] = useState(false);
    const evaluate4DownloadsRef = useRef<HTMLDivElement | null>(null);
    useClickOutside(evaluate4DownloadsRef, () => setOpen(false));

    const runDownload = (fn: (id: number) => ReturnType<typeof downloadBidConditions>) => {
        if (!tenderId) {
            message.error('Something went wrong, please try again');
            return;
        }
        setOpen(false);
        fn(tenderId)
            .then((res) => {
                const blobUrl = window.URL.createObjectURL(res?.data);
                window.open(blobUrl, '_blank');
            })
            .catch(() => {
                message.error('Unable to download. Please try again.');
            });
    };

    const runPricingBreakdownDownload = () => {
        const uuid = pricingBreakdownFileUuid?.trim();
        if (!uuid) {
            message.warning('Pricing breakdown file is not available yet.');
            return;
        }
        setOpen(false);
        const fallbackName = pricingBreakdownFileName?.trim() || 'Pricing-breakdown';
        downloadSingleFileFunc(uuid)
            .then((res) => {
                saveBlobResponseAsDownload(res as { data: Blob; headers: Record<string, unknown> }, fallbackName);
            })
            .catch(() => {
                message.error('Unable to download. Please try again.');
            });
    };

    return (
        <div className="evaluate4-su-downloads" ref={evaluate4DownloadsRef}>
            <div className="supplier-card__btns">
                <div style={{ position: 'relative' }}>
                    <button
                        type="button"
                        className={`evaluate4-su-downloads__trigger${
                            open ? ' evaluate4-su-downloads__trigger--open' : ''
                        }`}
                        onClick={() => setOpen((p) => !p)}
                    >
                        Documents
                        <img src={arrow} alt="" />
                    </button>
                    {open && (
                        <div className="evaluate4-su-downloads__menu">
                            <button
                                type="button"
                                className="evaluate4-su-downloads__item"
                                onClick={() => runDownload(downloadBidConditions)}
                            >
                                <img src={download} alt="" />
                                Bid Conditions
                            </button>
                            <button
                                type="button"
                                className="evaluate4-su-downloads__item"
                                onClick={() => runDownload(downloadMatchmakingReportPdf)}
                            >
                                <img src={download} alt="" />
                                Matchmaking Report
                            </button>
                            <Tooltip
                                title={
                                    pricingBreakdownFileUuid?.trim()
                                        ? undefined
                                        : 'Pricing breakdown file is not available yet'
                                }
                                overlayClassName={
                                    pricingBreakdownFileUuid?.trim() ? undefined : 'custom-tooltip-disabled'
                                }
                            >
                                <span style={{ display: 'block' }}>
                                    <button
                                        type="button"
                                        className="evaluate4-su-downloads__item"
                                        disabled={!pricingBreakdownFileUuid?.trim()}
                                        onClick={runPricingBreakdownDownload}
                                    >
                                        <img src={download} alt="" />
                                        Pricing Breakdown
                                    </button>
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

/** Pending Verification tab: same rules as backend (invite id set, docs received, company pending TPA or unverified). */
const isInvitedSupplierPendingVerification = (elem: invitedSupplierI): boolean => {
    if (elem.id == null) return false;
    const docStatus = elem.company?.document_status ?? elem.company_document_status;
    if (docStatus !== 'received') return false;
    const companySt = elem.company?.status ?? elem.company_status;
    return companySt === 'pending_tpa' || companySt === 'unverified';
};

export const SupplierListNew: FC<DefineSupportingDocumentTaskProps> = ({ data, role, messageApi, setTrigger }) => {
    const [supplierModal, setSupplierModal] = useState(false);
    const [SupplierData, setSupplierData] = useState<any>(null);
    const [taskId, setTaskId] = useState<number | null>(null);
    const [isCreateSupplierModal, setIsCreateSupplierModal] = useState(false);
    const [isRejectIncumbentModal, setIsRejectIncumbentModal] = useState(false);
    const [isRejectModal, setIsRejectModal] = useState(false);
    const [isRejectSupplierModal, setIsRejectSupplierModal] = useState(false);

    const [updateGrade, { isSuccess: isSuccessUpdatedGrade }] = useUpdateGradeMutation();
    const [deleteSupplier, { data: deletedData, isSuccess: isSuccessDeleted, isLoading: isLoadingDelete }] =
        useDeleteSupplierMutation();
    const [resedInvites, { isSuccess: isSuccessResendInvite, isError: isErrorResendInvite }] =
        useResendInvitesToSuppliersMutation();
    const [resedInvitesCompany, { isSuccess: isSuccessResendInviteCompany, isError: isErrorResendInviteCompany }] =
        useResendInviteSupplierCompaniesMutation();
    const [
        deleteSupplierInvite,
        { data: deletedDataInvite, isSuccess: isSuccessDeletedInvite, isLoading: isLoadingDeleteInvite }
    ] = useDeleteSupplierInviteMutation();
    const [
        deleteSupplierAward,
        { data: deletedDataAward, isSuccess: isSuccessDeletedAward, isLoading: isLoadingDeleteAward }
    ] = useDeleteSupplierAwardMutation();
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [isEditModal, setIsEditModal] = useState(false);
    const [openEditCandidateModal, setOpenEditCandidateModal] = useState(false);
    const [editCandidateSupplier, setEditCandidateSupplier] = useState<SupplierI | null>(null);
    const [, setAddSuppInfoModalStub] = useState(false);
    const [updateIncumbent, { isSuccess: isSuccessUpdateIncumbent }] = useUpdateIncumbentMutation();
    const [updateIncumbentInTender, { isSuccess: isSuccessUpdateIncumbentInTender }] =
        useUpdateIncumbentInTenderMutation();
    const [selectedSupplier, setSelectedSupplier] = useState<SupplierI | null>(null);
    const [shortlist, { data: shortlistData, isSuccess, isLoading: isLoadingShortList }] =
        useShortlistSupplierMutation();
    const [openManage, setOpenManage] = useState<number | null>(null);
    const [grades, setGrades] = useState<{ id: number; grade: any }[]>([]);
    const ref = useRef<HTMLDivElement | null>(null);
    useClickOutside(ref, () => setOpenManage(null));
    const [serviceSpecDropdownOpen, setServiceSpecDropdownOpen] = useState(false);
    const serviceSpecRef = useRef<HTMLDivElement | null>(null);
    const serviceSpecLeaveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    useClickOutside(serviceSpecRef, () => {
        const t = serviceSpecLeaveTimerRef.current;
        if (t != null) clearTimeout(t);
        serviceSpecLeaveTimerRef.current = null;
        setServiceSpecDropdownOpen(false);
    });

    const onServiceSpecMouseEnter = () => {
        const t = serviceSpecLeaveTimerRef.current;
        if (t != null) {
            clearTimeout(t);
            serviceSpecLeaveTimerRef.current = null;
        }
        setServiceSpecDropdownOpen(true);
    };

    const onServiceSpecMouseLeave = () => {
        const t = serviceSpecLeaveTimerRef.current;
        if (t != null) clearTimeout(t);
        serviceSpecLeaveTimerRef.current = setTimeout(() => {
            setServiceSpecDropdownOpen(false);
            serviceSpecLeaveTimerRef.current = null;
        }, 120);
    };

    useEffect(() => {
        return () => {
            const t = serviceSpecLeaveTimerRef.current;
            if (t != null) clearTimeout(t);
        };
    }, []);
    const [openState, setOpenState] = useState<{ id: number; open: boolean }[]>([]);
    const [isSuppAwardModal, setIsSuppAwardModal] = useState(false);
    const [isAgreementLinkModal, setIsAgreementLinkModal] = useState(false);
    const [openSuppList, setOpenSuppList] = useState(false);
    const [type, setType] = useState<string>('all');
    const [incumbentSupp, setIncumbentSupp] = useState<any>(null);
    const [supplierPriceInfoModalOpen, setSupplierPriceInfoModalOpen] = useState(false);
    const [supplierForPriceInfo, setSupplierForPriceInfo] = useState<SupplierI | null>(null);

    console.log('incumbentSupp', incumbentSupp);

    useEffect(() => {
        if (isSuccessResendInvite || isSuccessResendInviteCompany) {
            message.success('The invitation was successfully sent.');
        }
    }, [isSuccessResendInvite, isSuccessResendInviteCompany]);

    useEffect(() => {
        if (isErrorResendInvite || isErrorResendInviteCompany) {
            message.error('Something went wrong, please try again');
        }
    }, [isErrorResendInvite, isErrorResendInviteCompany]);

    useEffect(() => {
        if (isSuccessUpdatedGrade) {
            setTrigger((prev) => !prev);
        }
    }, [isSuccessUpdatedGrade]);

    useEffect(() => {
        if (data) {
            const grades = data?.suppliers?.map((elem) => ({
                id: elem.id,
                grade: elem?.grade?.value ? elem?.grade?.value : null
            }));
            setGrades(grades);

            const opens = data?.suppliers?.map((elem) => ({
                id: elem.id,
                open: false
            }));
            setOpenState(opens);
        }
    }, [data]);

    useEffect(() => {
        if (isSuccess) {
            setTrigger((prev: boolean) => !prev);
            messageApi?.success(shortlistData?.message);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isSuccessDeleted || isSuccessDeletedInvite || isSuccessDeletedAward) {
            setTrigger((prev) => !prev);
            setIsDeleteModal(false);

            if (isSuccessDeleted) {
                message.success(deletedData?.message);
            }
            if (isSuccessDeletedInvite) {
                message.success(deletedDataInvite?.message);
            }
            if (isSuccessDeletedAward) {
                message.success(deletedDataAward?.message);
            }
        }
    }, [isSuccessDeleted, isSuccessDeletedInvite, isSuccessDeletedAward]);

    const copyAllEmails = async (suppliers?: SupplierI[]) => {
        const emails =
            suppliers !== undefined
                ? collectTenderSupplierEmails(suppliers)
                : collectInvitedSupplierEmails(data?.invited_suppliers?.items ?? []);

        await copyEmailsToClipboard(emails);
    };
    const copyAllEmailsInTender = () => copyAllEmails(data?.suppliers ?? []);

    useEffect(() => {
        if (isSuccessUpdateIncumbent || isSuccessUpdateIncumbentInTender) {
            setTrigger((prev: boolean) => !prev);
        }
    }, [isSuccessUpdateIncumbent, isSuccessUpdateIncumbentInTender]);

    const statusImage = (status: string) => {
        if (status === 'Unverified') {
            return Unverified;
        }
        if (status === 'Verified') {
            return Verified;
        }
        if (status === 'Not Provided') {
            return NotProvided;
        }
        if (status === 'Requested') {
            return Requested;
        }
        if (status === 'Received') {
            return Received;
        }
    };

    const deleteSupplierFunc = async () => {
        if (isLoadingDelete || isLoadingDeleteInvite || isLoadingDeleteAward) return;
        try {
            if (data?.phase === 'design' || data?.phase === 'launch') {
                const dataToPost = {
                    tender_id: data.id,
                    invite_id: SupplierData?.id
                };
                deleteSupplierInvite(dataToPost);
            } else if (data?.phase === 'award') {
                const dataToPost = {
                    tenderId: data.id,
                    supplierId: SupplierData?.id
                };
                deleteSupplierAward(dataToPost);
            } else {
                const dataToPost = {
                    tender_id: data.id,
                    supplierId: SupplierData?.id
                };
                deleteSupplier(dataToPost);
            }
        } catch {}
    };

    const resendInviteNotCandidate = (id: number) => {
        try {
            const dataToPost = {
                tender_id: data.id,
                invite_id: id
            };
            resedInvitesCompany(dataToPost);
        } catch {}
    };

    const resedInvitesFunc = async (id: number) => {
        try {
            const dataToPost = {
                tender_id: data.id,
                supp_id: id
            };
            resedInvites(dataToPost);
        } catch {}
    };

    const shortlistFunc = async (id: number) => {
        try {
            const dataToPost = {
                tenderId: data.id,
                supplierId: id
            };
            shortlist(dataToPost);
        } catch {}
    };

    const classNameOfCompletedSuppliersCounter = (number: number) => {
        if (number === 0) {
            return 'grey';
        }
        if (number >= 1 && number <= 5) {
            return 'red';
        }
        if (number >= 6 && number <= 9) {
            return 'yellow';
        }
        if (number >= 10) {
            return 'green';
        }
    };

    const handleKeyPressNumbersOnly = (e: ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value;
        const onlyNumbers = input.replace(/[^0-9]/g, '');
        const limitedValue = parseInt(onlyNumbers, 10) > 100 ? '100' : onlyNumbers;
        e.target.value = limitedValue;
    };

    const classNameOfGrade = (key: string) => {
        if (key === 'A') {
            return 'light-Green';
        }
        if (key === 'B') {
            return 'Dark-Green';
        }
        if (key === 'C') {
            return 'Yellow';
        }
        if (key === 'D') {
            return 'Orange';
        }
        if (key === 'F') {
            return 'Brown';
        }
        if (key === 'E') {
            return 'Red';
        }
    };

    const renderManagerInfo = (elem: any) => {
        return (
            <div className="newSupplier__manager">
                <div className="newSupplier__manager-title">
                    {elem.manager?.name ? elem.manager.name : ''}
                    <div
                        className={`newSupplier__status_name ${
                            elem.status_name === 'Unconfirmed' ? 'Unconfirmed' : 'Confirmed'
                        }`}
                    >
                        <img src={elem.status_name === 'Unconfirmed' ? Unconfirmed : Confirmed} /> {elem.status_name}
                    </div>
                </div>
                <div className="newSupplier__subtitle">
                    <img src={phone} /> {elem.manager?.phone_number ? elem.manager?.phone_number : ''}
                    <img src={email} /> {elem.manager?.email ? elem.manager?.email : ''}
                </div>
            </div>
        );
    };

    const getCandidateDisplayEmail = (supp: { company?: { candidate_email?: string | null } }) =>
        (supp?.company?.candidate_email?.trim() || '') as string;

    /** Invited candidate (no manager): same two-field modal as add/edit supplier — `AddSupplierModal` + PUT supplier-candidates */
    const openEditInviteForCandidateEmail = (supp: any) => {
        const em = getCandidateDisplayEmail(supp);
        setEditCandidateSupplier({
            id: supp.company.candidate_id,
            company_name: supp.company.name,
            email: em
        } as SupplierI);
        setOpenEditCandidateModal(true);
    };

    /** Email row: mail icon, address, edit (see invite-candidate-email-row in phases.scss) — e.g. when manager missing */
    const renderCandidateEmailRow = (supp: any) => {
        if (supp.manager?.name) return null;
        const em = (supp?.company?.candidate_email?.trim() || '') as string;
        if (!em) return null;
        return (
            <div className="invite-candidate-email-row">
                <div className="newSupplier__subtitle invite-candidate-email-row__mail">
                    <img src={email} alt="" />
                    <span>{em}</span>
                </div>
                <button
                    type="button"
                    className="invite-candidate-email-row__edit"
                    onClick={() => openEditInviteForCandidateEmail(supp)}
                    aria-label="Edit supplier contact"
                >
                    <img src={editIcon} alt="" />
                </button>
            </div>
        );
    };

    const supplierList = data?.invited_suppliers?.items;

    const options = [
        { label: `All (${supplierList?.length})`, value: 'all' },
        {
            label: `Pending Verification (${data?.invited_suppliers?.pending_verification})`,
            value: 'pending'
        },
        {
            label: `Registered (${data?.invited_suppliers?.completed_registration})`,
            value: 'registered'
        }
    ];

    const filteredSuppList = (() => {
        const list = supplierList?.filter((elem) => {
            if (type === 'all') {
                return elem;
            }
            if (type === 'pending') {
                return isInvitedSupplierPendingVerification(elem);
            }
            if (type === 'registered') {
                return elem.registration_status === 'registered';
            }
        });
        if (!list || type !== 'all') return list;
        return [...list].sort((a, b) => {
            const aReg = a.registration_status === 'registered' ? 1 : 0;
            const bReg = b.registration_status === 'registered' ? 1 : 0;
            return bReg - aReg;
        });
    })();

    return (
        <>
            {data?.phase_tasks.length > 0 &&
                data?.phase_tasks.map((elem: taskProps) => {
                    if (elem.action === 'design_suppliers') {
                        if (role === 'onboarding_representative') {
                            if (data.invited_suppliers.items.length < 1) {
                                return (
                                    <div key={3} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>

                                        <img
                                            src={plus}
                                            className="task__plus"
                                            onClick={() => {
                                                setSupplierModal(true);
                                            }}
                                        />
                                    </div>
                                );
                            }
                            if (data.invited_suppliers.items.length >= 1) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                              `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="custom-radio-field large">
                                                <Radio.Group
                                                    value={type}
                                                    className={`notif-radio-switcher`}
                                                    onChange={(e) => setType(e.target.value)}
                                                >
                                                    {options.map((option) => (
                                                        <Radio.Button key={option.value} value={option.value}>
                                                            {option.label}
                                                        </Radio.Button>
                                                    ))}
                                                </Radio.Group>
                                            </div>
                                        </div>

                                        {filteredSuppList.map((supp) => {
                                            const status = supp.company.status_name;
                                            const need_update = supp.company.need_update_profile;
                                            const docName = supp.company.document_status_name;
                                            return (
                                                <div className="newSupplier">
                                                    <div className="newSupplier__header">
                                                        <div className="newSupplier__header-wrap">
                                                            <div className="newSupplier__header-title">
                                                                {status && (
                                                                    <div className="newSupplier__status">
                                                                        <img
                                                                            src={statusImage(supp.company.status_name)}
                                                                        />{' '}
                                                                        {status}
                                                                    </div>
                                                                )}
                                                                {supp.company.name}{' '}
                                                                {need_update && (
                                                                    <Tooltip title="Outdated profile data">
                                                                        <img src={attention} />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                            {supp?.company?.is_candidate && (
                                                                <div className="newSupplier__added">Added by buyer</div>
                                                            )}
                                                        </div>
                                                        <div
                                                            className={`newSupplier__header-wrap ${supp?.registration_status}`}
                                                        >
                                                            {capitalize(supp?.registration_status)}
                                                        </div>
                                                    </div>
                                                    {renderCandidateEmailRow(supp)}
                                                    <div className="newSupplier__row">
                                                        <div className="newSupplier__col">
                                                            {docName && (
                                                                <div className="newSupplier__doc">
                                                                    <img src={statusImage(docName)} />
                                                                    {docName}
                                                                </div>
                                                            )}
                                                            {supp.manager?.name ? (
                                                                renderManagerInfo(supp)
                                                            ) : !supp?.company?.candidate_email ? (
                                                                <div className="newSupplier__wrap"></div>
                                                            ) : null}
                                                        </div>
                                                        <div className="newSupplier__col btns">
                                                            {(supp?.status === 'sent' ||
                                                                supp?.status === 'unconfirmed' ||
                                                                supp?.status === 'confirmation') && (
                                                                <Button
                                                                    onClick={() => {
                                                                        if (
                                                                            supp.company.id === null &&
                                                                            supp.company.candidate_id
                                                                        ) {
                                                                            resedInvitesFunc(supp.company.candidate_id);
                                                                        }
                                                                        if (supp.company.id) {
                                                                            resendInviteNotCandidate(supp.company.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    Resend Invite
                                                                </Button>
                                                            )}

                                                            {supp.company.id && (
                                                                <Button
                                                                    onClick={() => {
                                                                        window.open(
                                                                            `/admin-panel/suppliers?id=${supp.company?.id}`,
                                                                            '_blank'
                                                                        );
                                                                    }}
                                                                >
                                                                    View Details
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                        if (role === 'tender_representative' || role === 'super_admin') {
                            if (data.invited_suppliers.items.length < 1) {
                                return (
                                    <div key={3} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>
                                    </div>
                                );
                            }
                            if (data.invited_suppliers.items.length >= 1) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                              `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                                <div
                                                    className={`task-complete__i-wrap ${classNameOfCompletedSuppliersCounter(
                                                        data.invited_suppliers.completed_registration
                                                    )}`}
                                                >
                                                    {data.invited_suppliers.completed_registration}
                                                    <Tooltip
                                                        title={
                                                            <div className="tooltip-light">
                                                                <div className="tooltip-light__row">
                                                                    <div>Reminders Sent</div>
                                                                    <div className="tooltip-light__number">
                                                                        {data.invited_suppliers.only_registered}
                                                                    </div>
                                                                </div>
                                                                <div className="tooltip-light__row">
                                                                    <div>Completed Registrations</div>
                                                                    <div className="tooltip-light__number">
                                                                        {data.invited_suppliers.completed_registration}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        className={'tooltip-white'}
                                                    >
                                                        <img src={i} className="task-complete__i" />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="task__copyemails" onClick={() => copyAllEmails()}>
                                                <img src={copyImage} />
                                                Copy all Emails
                                            </div>
                                        </div>

                                        {data.invited_suppliers.items.map((elem) => {
                                            return (
                                                <div className="task-complete__supplier supplier">
                                                    <div className="supplier__header with-switcher">
                                                        <div className="supplier__wrapper">
                                                            <img src={statusImage(elem.company.status_name)} />{' '}
                                                            {elem.company.status_name}
                                                        </div>
                                                        <div className="supplier__wrapper switcher">
                                                            Incumbent
                                                            <Switch
                                                                checked={elem.incumbent}
                                                                size="small"
                                                                className="custom-switch"
                                                                onChange={() => {
                                                                    const dataToPost = {
                                                                        tender_id: data.id,
                                                                        invite_id: elem.id
                                                                    };
                                                                    updateIncumbent(dataToPost);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {renderCandidateEmailRow(elem)}
                                                    <div className="supplier__row">
                                                        <div className="supplier__wrap first">
                                                            <div className="supplier__title">{elem.company.name}</div>
                                                            <div className="supplier__subtitle">
                                                                {elem.company.trading_name}
                                                            </div>
                                                        </div>
                                                        {elem.manager?.name ? (
                                                            <div className="supplier__wrap">
                                                                <div className="supplier__title">
                                                                    {elem.manager?.name ? elem.manager.name : ''}
                                                                    <div
                                                                        className={`supplier__status ${
                                                                            elem.status_name === 'Unconfirmed'
                                                                                ? 'Unconfirmed'
                                                                                : 'Confirmed'
                                                                        }`}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                elem.status_name === 'Unconfirmed'
                                                                                    ? Unconfirmed
                                                                                    : Confirmed
                                                                            }
                                                                        />{' '}
                                                                        {elem.status_name}
                                                                    </div>
                                                                </div>
                                                                <div className="supplier__subtitle">
                                                                    {elem.manager?.email ? elem.manager?.email : ''}{' '}
                                                                    {elem.manager?.phone_number
                                                                        ? elem.manager?.phone_number
                                                                        : ''}
                                                                </div>
                                                            </div>
                                                        ) : !elem?.company?.candidate_email ? (
                                                            <div className="supplier__wrap"></div>
                                                        ) : null}
                                                        {elem.manager?.name && (
                                                            <img
                                                                src={editIcon}
                                                                className="supplier__delete"
                                                                onClick={() => {
                                                                    setTaskId(elem.id);
                                                                    setSupplierData(elem);
                                                                    setIsEditModal(true);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'launch_suppliers') {
                        if (role === 'onboarding_representative') {
                            if (data.invited_suppliers.items.length < 1) {
                                return (
                                    <div key={3} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>

                                        <img
                                            src={plus}
                                            className="task__plus"
                                            onClick={() => {
                                                setSupplierModal(true);
                                            }}
                                        />
                                    </div>
                                );
                            }
                            if (data.invited_suppliers.items.length >= 1) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                              `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="custom-radio-field large">
                                                <Radio.Group
                                                    value={type}
                                                    className={`notif-radio-switcher`}
                                                    onChange={(e) => setType(e.target.value)}
                                                >
                                                    {options.map((option) => (
                                                        <Radio.Button key={option.value} value={option.value}>
                                                            {option.label}
                                                        </Radio.Button>
                                                    ))}
                                                </Radio.Group>
                                            </div>
                                        </div>

                                        {filteredSuppList.map((supp) => {
                                            const status = supp.company.status_name;
                                            const need_update = supp.company.need_update_profile;
                                            const docName = supp.company.document_status_name;
                                            return (
                                                <div className="newSupplier">
                                                    <div className="newSupplier__header">
                                                        <div className="newSupplier__header-wrap">
                                                            <div className="newSupplier__header-title">
                                                                {status && (
                                                                    <div className="newSupplier__status">
                                                                        <img
                                                                            src={statusImage(supp.company.status_name)}
                                                                        />{' '}
                                                                        {status}
                                                                    </div>
                                                                )}
                                                                {supp.company.name}{' '}
                                                                {need_update && (
                                                                    <Tooltip title="Outdated profile data">
                                                                        <img src={attention} />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                            {supp?.company?.is_candidate && (
                                                                <div className="newSupplier__added">Added by buyer</div>
                                                            )}
                                                        </div>
                                                        <div
                                                            className={`newSupplier__header-wrap ${supp?.registration_status}`}
                                                        >
                                                            {capitalize(supp?.registration_status)}
                                                        </div>
                                                    </div>
                                                    {renderCandidateEmailRow(supp)}
                                                    <div className="newSupplier__row">
                                                        <div className="newSupplier__col">
                                                            {docName && (
                                                                <div className="newSupplier__doc">
                                                                    <img src={statusImage(docName)} />
                                                                    {docName}
                                                                </div>
                                                            )}
                                                            {supp.manager?.name ? (
                                                                renderManagerInfo(supp)
                                                            ) : !supp?.company?.candidate_email ? (
                                                                <div className="newSupplier__wrap"></div>
                                                            ) : null}
                                                        </div>
                                                        <div className="newSupplier__col btns">
                                                            {(supp?.status === 'sent' ||
                                                                supp?.status === 'unconfirmed' ||
                                                                supp?.status === 'confirmation') && (
                                                                <Button
                                                                    onClick={() => {
                                                                        if (
                                                                            supp.company.id === null &&
                                                                            supp.company.candidate_id
                                                                        ) {
                                                                            resedInvitesFunc(supp.company.candidate_id);
                                                                        }
                                                                        if (supp.company.id) {
                                                                            resendInviteNotCandidate(supp.company.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    Resend Invite
                                                                </Button>
                                                            )}

                                                            {supp.company.id && (
                                                                <Button
                                                                    onClick={() => {
                                                                        window.open(
                                                                            `/admin-panel/suppliers?id=${supp.company?.id}`,
                                                                            '_blank'
                                                                        );
                                                                    }}
                                                                >
                                                                    View Details
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                        if (role === 'tender_representative' || role === 'super_admin') {
                            if (data.invited_suppliers.items.length < 1) {
                                return (
                                    <div key={3} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>
                                    </div>
                                );
                            }
                            if (data.invited_suppliers.items.length >= 1) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                              `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                                <div
                                                    className={`task-complete__i-wrap ${classNameOfCompletedSuppliersCounter(
                                                        data.invited_suppliers.completed_registration
                                                    )}`}
                                                >
                                                    {data.invited_suppliers.completed_registration}
                                                    <Tooltip
                                                        title={
                                                            <div className="tooltip-light">
                                                                <div className="tooltip-light__row">
                                                                    <div>Reminders Sent</div>
                                                                    <div className="tooltip-light__number">
                                                                        {data.invited_suppliers.only_registered}
                                                                    </div>
                                                                </div>
                                                                <div className="tooltip-light__row">
                                                                    <div>Completed Registrations</div>
                                                                    <div className="tooltip-light__number">
                                                                        {data.invited_suppliers.completed_registration}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        className={'tooltip-white'}
                                                    >
                                                        <img src={i} className="task-complete__i" />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="task__copyemails" onClick={() => copyAllEmails()}>
                                                <img src={copyImage} />
                                                Copy all Emails
                                            </div>
                                        </div>

                                        {data.invited_suppliers.items.map((supp) => {
                                            const need_update = supp.company.need_update_profile;

                                            return (
                                                <div className="task-complete__supplier supplier">
                                                    <div className="supplier__header with-switcher">
                                                        <div className="supplier__row">
                                                            <div className="supplier__wrapper">
                                                                <img src={statusImage(supp.company.status_name)} />{' '}
                                                                {supp.company.status_name}
                                                            </div>

                                                            {supp?.company?.is_candidate && (
                                                                <div className="newSupplier__added">Added by buyer</div>
                                                            )}
                                                        </div>
                                                        <div
                                                            className={`newSupplier__header-wrap ${supp?.registration_status}`}
                                                        >
                                                            {capitalize(supp?.registration_status)}
                                                        </div>
                                                    </div>
                                                    {renderCandidateEmailRow(supp)}
                                                    <div className="supplier__row">
                                                        <div className="supplier__wrap first">
                                                            <div className="supplier__title">
                                                                {supp.company.name}{' '}
                                                                {need_update && (
                                                                    <Tooltip title="Outdated profile data">
                                                                        <img
                                                                            src={attention}
                                                                            style={{ margin: '0 8px' }}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                            <div className="supplier__subtitle">
                                                                {supp.company.trading_name}
                                                            </div>
                                                            {supp.incumbent === null &&
                                                                supp.registration_status === 'registered' && (
                                                                    <Button
                                                                        className="blue-btn"
                                                                        onClick={() => setIncumbentSupp(supp)}
                                                                    >
                                                                        Select Incumbent Status
                                                                    </Button>
                                                                )}
                                                        </div>
                                                        {supp.manager?.name ? (
                                                            <div className="supplier__wrap">
                                                                <div className="supplier__title">
                                                                    {supp.manager?.name ? supp.manager.name : ''}
                                                                    <div
                                                                        className={`supplier__status ${
                                                                            supp.status_name === 'Unconfirmed'
                                                                                ? 'Unconfirmed'
                                                                                : 'Confirmed'
                                                                        }`}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                supp.status_name === 'Unconfirmed'
                                                                                    ? Unconfirmed
                                                                                    : Confirmed
                                                                            }
                                                                        />{' '}
                                                                        {supp.status_name}
                                                                    </div>
                                                                </div>
                                                                <div className="supplier__subtitle">
                                                                    {supp.manager?.email ? supp.manager?.email : ''}{' '}
                                                                    {supp.manager?.phone_number
                                                                        ? supp.manager?.phone_number
                                                                        : ''}
                                                                </div>
                                                            </div>
                                                        ) : !supp?.company?.candidate_email ? (
                                                            <div className="supplier__wrap"></div>
                                                        ) : null}
                                                        {supp.manager?.name && (
                                                            <img
                                                                src={editIcon}
                                                                className="supplier__delete"
                                                                onClick={() => {
                                                                    setTaskId(supp.id);
                                                                    setSupplierData(supp);
                                                                    setIsEditModal(true);
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <Divider style={{ margin: '0' }} />
                                                    <div className="supplier__row">
                                                        {supp?.incumbent === true ? (
                                                            <div className="isIncumbent">
                                                                <img src={incumbent} />
                                                                Incumbent Participation{' '}
                                                                <Edit
                                                                    fill="#001965"
                                                                    onClick={() => setIncumbentSupp(supp)}
                                                                />
                                                            </div>
                                                        ) : supp?.incumbent === false ? (
                                                            <div className="isIncumbent">
                                                                <img src={notIncumbent} />
                                                                Not Incumbent Participation{' '}
                                                                <Edit
                                                                    fill="#001965"
                                                                    onClick={() => setIncumbentSupp(supp)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'evaluate_1_2_suppliers') {
                        if (role !== 'school_user') {
                            if (elem.status === 'pending_su') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                              `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__row-btns">
                                                <div
                                                    className="task__copyemails"
                                                    onClick={copyAllEmailsInTender}
                                                    style={{ margin: '0 15px 0 0' }}
                                                >
                                                    <img src={copyImage} />
                                                    Copy all Emails
                                                </div>
                                            </div>
                                        </div>

                                        {data.suppliers.map((elem) => {
                                            return (
                                                <SupplierCardForTR
                                                    elem={elem}
                                                    setIsEditModal={setIsEditModal}
                                                    setSupplierData={setSupplierData}
                                                    setTaskId={setTaskId}
                                                />
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su' && data.suppliers.length) {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            data.can_send_task ? 'green' : ''
                                        }`}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row">
                                                <div
                                                    className="supplier-SU__white-btn"
                                                    onClick={() => {
                                                        downloadCapabilityProfile(data?.id).then((res) => {
                                                            const blobUrl = window.URL.createObjectURL(res?.data);
                                                            window.open(blobUrl, '_blank');
                                                        });
                                                    }}
                                                >
                                                    Supplier Capability Profile
                                                    <img src={download} className={'supplier-SU__white-btn-icon'} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="task-complete__supplier-list">
                                            {data?.suppliers.map((item: SupplierI, index: number) => {
                                                return (
                                                    <SupplierCardEvaluate1
                                                        item={item}
                                                        setIsRejectIncumbentModal={setIsRejectIncumbentModal}
                                                        setIsRejectModal={setIsRejectModal}
                                                        setSelectedSupplier={setSelectedSupplier}
                                                        setTaskId={setTaskId}
                                                        data={data}
                                                        shortlistFunc={shortlistFunc}
                                                        isLoadingShortList={isLoadingShortList}
                                                        index={index}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'need_resend_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            data.can_send_task ? 'green' : ''
                                        }`}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row">
                                                <div
                                                    className="supplier-SU__white-btn"
                                                    onClick={() => {
                                                        downloadProfileSummary(data?.id).then((res) => {
                                                            const blobUrl = window.URL.createObjectURL(res?.data);
                                                            window.open(blobUrl, '_blank');
                                                        });
                                                    }}
                                                >
                                                    Supplier Profile Summary
                                                    <img src={download} className={'supplier-SU__white-btn-icon'} />
                                                </div>
                                            </div>
                                            <div className="task__pending" key={elem.id}>
                                                <img src={pendingIcon} />
                                                Pending
                                            </div>
                                        </div>

                                        <div className="task-complete__supplier-list">
                                            {data?.suppliers.map((item: SupplierI) => {
                                                return (
                                                    <>
                                                        <div className="task-complete__supplier supplier supplier-SU">
                                                            <div className="supplier-SU__row">
                                                                <div className="supplier__column">
                                                                    <div className="supplier__row">
                                                                        <Tooltip
                                                                            title="A verified status indicates that the supplier`s company documentation has been reviewed and confirmed"
                                                                            overlayClassName={` ${
                                                                                item.company_status_name === 'Verified'
                                                                                    ? 'custom-tooltip-disabled left'
                                                                                    : 'custom-tooltip '
                                                                            }`}
                                                                        >
                                                                            {item.company_status_name ===
                                                                            'Unverified' ? (
                                                                                <></>
                                                                            ) : (
                                                                                <div className="supplier_status">
                                                                                    <img
                                                                                        src={statusImage(
                                                                                            item.company_status_name
                                                                                        )}
                                                                                    />{' '}
                                                                                    {item.company_status_name}
                                                                                </div>
                                                                            )}
                                                                        </Tooltip>
                                                                        {item.incumbent && (
                                                                            <div className="supplier__incumbent">
                                                                                <img src={attantion} />
                                                                                Incumbent Supplier
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="supplier-SU__name">
                                                                        ({item.name_prefix}) {item.name}
                                                                    </div>
                                                                    <div className="supplier-SU__trading_name">
                                                                        {item.trading_name}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="supplier__row"
                                                                    style={{ justifyContent: 'end' }}
                                                                >
                                                                    <div className="supplier__grade grade SU">
                                                                        <ScoreHistory item={item} />

                                                                        <div
                                                                            className={`grade__value_wrapper ${classNameOfGrade(
                                                                                item.grade.key
                                                                            )}`}
                                                                        >
                                                                            Grade {item.grade?.key}
                                                                        </div>
                                                                    </div>
                                                                    <div className="grade__border"></div>
                                                                    <div>
                                                                        {item.status === 'rejected' && (
                                                                            <div className="task-complete__title-row">
                                                                                <div
                                                                                    className="task-complete__decline-active"
                                                                                    style={{ margin: '0 15px 0 0' }}
                                                                                >
                                                                                    <img src={stopImage} />
                                                                                    Rejected
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {item.status === 'shortlisted' && (
                                                                            <div className="task-complete__title-row">
                                                                                <div className="task-complete__approved-active">
                                                                                    <img src={done} />
                                                                                    Shortlisted
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {(item?.comments?.su_rejected_comment ||
                                                                item.comments?.su_rejected_category_name) && (
                                                                <div
                                                                    className="task-complete__info-wrap"
                                                                    style={{ width: '100%' }}
                                                                >
                                                                    <div className="task-complete__wrap">
                                                                        <div className="task-complete__name">
                                                                            Reason for Rejection
                                                                        </div>
                                                                    </div>
                                                                    <div className="task-complete__wrap">
                                                                        <div className="task-complete__value">
                                                                            {item.comments.su_rejected_comment
                                                                                ? item.comments.su_rejected_comment
                                                                                : item.comments
                                                                                      ?.su_rejected_category_name}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {openState.find((state) => state.id === item.id)?.open ? (
                                                                <div className="supplier-SU__additional">
                                                                    <div className="supplier-SU__gray_row">
                                                                        <div className="supplier-SU__item">
                                                                            <div className="supplier-SU__item-name">
                                                                                B-BBEE
                                                                            </div>
                                                                            <div className="supplier-SU__item-value">
                                                                                {item.b_bbee}
                                                                            </div>
                                                                        </div>
                                                                        <div className="supplier-SU__item">
                                                                            <div className="supplier-SU__item-name">
                                                                                Number of Employees
                                                                            </div>
                                                                            <div className="supplier-SU__item-value">
                                                                                {item.employees_number}
                                                                            </div>
                                                                        </div>
                                                                        <div className="supplier-SU__item last">
                                                                            <div className="supplier-SU__item-name">
                                                                                Annual Revenue
                                                                            </div>
                                                                            <div className="supplier-SU__item-value">
                                                                                {item.annual_revenue}
                                                                            </div>
                                                                        </div>
                                                                        <a
                                                                            href={item.website}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div className="supplier-SU__white-btn">
                                                                                Visit Website <img src={Visit} />
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    {item.conflict_of_interest && (
                                                                        <div className="supplier-SU__add-text">
                                                                            <div className="supplier-SU__item-name">
                                                                                Potential conflict of interest
                                                                            </div>
                                                                            <div className="supplier-SU__conflict">
                                                                                <img src={messageIcon} />{' '}
                                                                                {item.conflict_of_interest}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div className="supplier-SU__add-text">
                                                                        {item.references.length > 0 && (
                                                                            <div className="supplier-SU__item-name">
                                                                                References:{' '}
                                                                            </div>
                                                                        )}
                                                                        <div className="supplier-SU__row-references">
                                                                            {item.references.map((ref) => {
                                                                                return (
                                                                                    <div className="supplier-SU__reference reference">
                                                                                        <div className="reference__item rating">
                                                                                            {ref.entity_name}
                                                                                            {ref?.rating && (
                                                                                                <div className="rating__item">
                                                                                                    {star()}
                                                                                                    {ref.rating}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                        <div className="reference__name">
                                                                                            {ref.contact_name}
                                                                                        </div>
                                                                                        <div className="reference__email">
                                                                                            {ref.email}{' '}
                                                                                            {ref.phone_number}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="supplier-SU__show"
                                                                        style={{ borderBottom: 'none' }}
                                                                        onClick={() => {
                                                                            const index = openState.findIndex(
                                                                                (state) => item.id === state.id
                                                                            );

                                                                            if (index !== -1) {
                                                                                const updatedStates = openState.map(
                                                                                    (state, i) =>
                                                                                        i === index
                                                                                            ? { ...state, open: false }
                                                                                            : state
                                                                                );
                                                                                setOpenState(updatedStates);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Hide Details{' '}
                                                                        <img
                                                                            src={arrow}
                                                                            style={{ transform: 'rotate(180deg)' }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className="supplier-SU__show"
                                                                    style={{ borderBottom: 'none' }}
                                                                    onClick={() => {
                                                                        const index = openState.findIndex(
                                                                            (state) => item.id === state.id
                                                                        );

                                                                        if (index !== -1) {
                                                                            const updatedStates = openState.map(
                                                                                (state, i) =>
                                                                                    i === index
                                                                                        ? { ...state, open: true }
                                                                                        : state
                                                                            );
                                                                            setOpenState(updatedStates);
                                                                        }
                                                                    }}
                                                                >
                                                                    Show Details <img src={arrow} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'evaluate_3_suppliers') {
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su') {
                                const documentLinks = phaseTaskDocumentLinks(elem);
                                return (
                                    <div key={elem.id} className={`tasks__task-complete task-complete`}>
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row">
                                                <div
                                                    className="supplier-SU__white-btn"
                                                    style={{ margin: '0 12px 0 0' }}
                                                    onClick={() => {
                                                        downloadSolutionGuide(data?.id).then((res) => {
                                                            const blobUrl = window.URL.createObjectURL(res?.data);
                                                            window.open(blobUrl, '_blank');
                                                        });
                                                    }}
                                                >
                                                    Supplier Pitch Guideline
                                                    <img src={download} className={'supplier-SU__white-btn-icon'} />
                                                </div>
                                                {documentLinks.length > 0 ? (
                                                    <div
                                                        className="service-spec"
                                                        ref={serviceSpecRef}
                                                        onMouseEnter={onServiceSpecMouseEnter}
                                                        onMouseLeave={onServiceSpecMouseLeave}
                                                    >
                                                        <div
                                                            className={`supplier-SU__white-btn${
                                                                serviceSpecDropdownOpen
                                                                    ? ' service-spec__trigger--open'
                                                                    : ''
                                                            }`}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            Service Specification
                                                            <img
                                                                src={download}
                                                                className={'supplier-SU__white-btn-icon'}
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div
                                                            className={`service-spec__panel${
                                                                serviceSpecDropdownOpen
                                                                    ? ' service-spec__panel--open'
                                                                    : ''
                                                            }`}
                                                            role="list"
                                                            aria-hidden={!serviceSpecDropdownOpen}
                                                        >
                                                            <div className="service-spec__content">
                                                                {documentLinks.map((doc, idx) => {
                                                                    const href = String(doc.link || doc.url || '');
                                                                    const label =
                                                                        doc.name?.trim() ||
                                                                        doc.title?.trim() ||
                                                                        `Service Specification ${idx + 1}`;
                                                                    return (
                                                                        <button
                                                                            type="button"
                                                                            className="service-spec__item"
                                                                            key={`${href}-${idx}`}
                                                                            tabIndex={serviceSpecDropdownOpen ? 0 : -1}
                                                                            onClick={() => {
                                                                                window.open(
                                                                                    href,
                                                                                    '_blank',
                                                                                    'noopener,noreferrer'
                                                                                );
                                                                                setServiceSpecDropdownOpen(false);
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={download}
                                                                                alt=""
                                                                                className="service-spec__item-icon"
                                                                            />
                                                                            <ServiceSpecTruncatedLabel label={label} />
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="task-complete__supplier-list">
                                            {data?.suppliers.map((item: SupplierI) => {
                                                return (
                                                    <SupplierEvaluate2SU
                                                        item={item}
                                                        setTrigger={setTrigger}
                                                        data={data}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'need_approve_su') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            data.can_send_task ? 'green' : ''
                                        }`}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                        </div>
                                        <div className="task-complete__supplier-list">
                                            {data?.suppliers.map((item: SupplierI, index: number) => {
                                                return (
                                                    <SupplierCardEvaluate1
                                                        item={item}
                                                        setIsRejectIncumbentModal={setIsRejectIncumbentModal}
                                                        setIsRejectModal={setIsRejectSupplierModal}
                                                        setSelectedSupplier={setSelectedSupplier}
                                                        setTaskId={setTaskId}
                                                        data={data}
                                                        shortlistFunc={shortlistFunc}
                                                        isLoadingShortList={isLoadingShortList}
                                                        index={index}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'need_approve_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            data.can_send_task ? 'green' : ''
                                        }`}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                        </div>
                                        <div className="task-complete__supplier-list">
                                            {data?.suppliers.map((item: SupplierI, index: number) => {
                                                return (
                                                    <SupplierCardEvaluate1
                                                        item={item}
                                                        setIsRejectIncumbentModal={setIsRejectIncumbentModal}
                                                        setIsRejectModal={setIsRejectSupplierModal}
                                                        setSelectedSupplier={setSelectedSupplier}
                                                        setTaskId={setTaskId}
                                                        data={data}
                                                        shortlistFunc={shortlistFunc}
                                                        isLoadingShortList={isLoadingShortList}
                                                        index={index}
                                                        hideActions
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                        } else {
                            if (elem.status === 'need_approve_su' || elem.status === 'pending_su') {
                                return (
                                    <div key={elem.id} className={`tasks__task-complete task-complete`} ref={ref}>
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div
                                                className="task__copyemails"
                                                onClick={() => copyAllEmails(data.suppliers)}
                                            >
                                                <img src={copyImage} />
                                                Copy all Emails
                                            </div>
                                        </div>

                                        {data.suppliers.map((item, index: number) => {
                                            return (
                                                <SupplierCardForTREvaluate2
                                                    elem={item}
                                                    setIsEditModal={setIsEditModal}
                                                    setSupplierData={setSupplierData}
                                                    setTaskId={setTaskId}
                                                />
                                            );
                                        })}
                                    </div>
                                );
                            }
                            if (elem.status === 'need_approve_tr') {
                                return (
                                    <div key={elem.id} className={`tasks__task-complete task-complete`} ref={ref}>
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div
                                                className="task__copyemails"
                                                onClick={() => copyAllEmails(data.suppliers)}
                                            >
                                                <img src={copyImage} />
                                                Copy all Emails
                                            </div>
                                        </div>

                                        {data.suppliers.map((item, index: number) => {
                                            return (
                                                <SupplierCardForTREvaluate2
                                                    elem={item}
                                                    setIsEditModal={setIsEditModal}
                                                    setSupplierData={setSupplierData}
                                                    setTaskId={setTaskId}
                                                />
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'evaluate_4_suppliers') {
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su' || elem.status === 'completed') {
                                const evaluate4PricingFile = getPricingBreakdownFileMeta(data);
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            allEvaluate4SuppliersStatusesFinal(data) ? 'green' : ''
                                        }`}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <Evaluate4SuDownloadsMenu
                                                tenderId={data?.id}
                                                pricingBreakdownFileUuid={evaluate4PricingFile.uuid}
                                                pricingBreakdownFileName={evaluate4PricingFile.name}
                                            />
                                        </div>
                                        <div className="task-complete__supplier-list">
                                            {data?.suppliers.map((item: SupplierI, index: number) => {
                                                return (
                                                    <SupplierCardEvaluate3SU
                                                        item={item}
                                                        setIsRejectIncumbentModal={setIsRejectIncumbentModal}
                                                        setIsRejectModal={setIsRejectSupplierModal}
                                                        setSelectedSupplier={setSelectedSupplier}
                                                        setTaskId={setTaskId}
                                                        data={data}
                                                        shortlistFunc={shortlistFunc}
                                                        isLoadingShortList={isLoadingShortList}
                                                        index={index}
                                                        status={elem.status}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            }
                            // if (elem.status === 'need_resend_tr') {
                            //     return (
                            //         <div
                            //             key={elem.id}
                            //             className={`tasks__task-complete task-complete ${
                            //                 allEvaluate4SuppliersStatusesFinal(data) ? 'green' : ''
                            //             }`}
                            //         >
                            //             <div className="task-complete__title">
                            //                 <div className="task-complete__title-row">
                            //                     <img src={SupplierListIcon} />
                            //                     {elem?.name}
                            //                 </div>
                            //                 <Evaluate4SuDownloadsMenu
                            //                     tenderId={data?.id}
                            //                     pricingBreakdownFileUuid={getPricingBreakdownFileMeta(data).uuid}
                            //                 />
                            //                 <div className="task__pending" key={elem.id}>
                            //                     <img src={pendingIcon} />
                            //                     Pending
                            //                 </div>
                            //             </div>
                            //             <div className="task-complete__supplier-list">
                            //                 {data?.suppliers.map((item: SupplierI) => {
                            //                     return (
                            //                         <>
                            //                             <div className="task-complete__supplier supplier supplier-SU">
                            //                                 <div className="supplier-SU__row">
                            //                                     <div className="supplier__column">
                            //                                         <div className="supplier__row">
                            //                                             <Tooltip
                            //                                                 title="A verified status indicates that the supplier`s company documentation has been reviewed and confirmed"
                            //                                                 overlayClassName={` ${
                            //                                                     item.company_status_name === 'Verified'
                            //                                                         ? 'custom-tooltip-disabled left'
                            //                                                         : 'custom-tooltip '
                            //                                                 }`}
                            //                                             >
                            //                                                 {item.company_status_name ===
                            //                                                 'Unverified' ? (
                            //                                                     <></>
                            //                                                 ) : (
                            //                                                     <div className="supplier_status">
                            //                                                         <img
                            //                                                             src={statusImage(
                            //                                                                 item.company_status_name
                            //                                                             )}
                            //                                                         />{' '}
                            //                                                         {item.company_status_name}
                            //                                                     </div>
                            //                                                 )}
                            //                                             </Tooltip>
                            //                                             {item.incumbent && (
                            //                                                 <div className="supplier__incumbent">
                            //                                                     <img src={attantion} />
                            //                                                     Incumbent Supplier
                            //                                                 </div>
                            //                                             )}
                            //                                         </div>
                            //                                         <div className="supplier-SU__name">
                            //                                             ({item.name_prefix}) {item.name}
                            //                                         </div>
                            //                                         <div className="supplier-SU__trading_name">
                            //                                             {item.trading_name}
                            //                                         </div>
                            //                                     </div>
                            //                                     <div
                            //                                         className="supplier__row"
                            //                                         style={{
                            //                                             justifyContent: 'end',
                            //                                             position: 'relative'
                            //                                         }}
                            //                                     >
                            //                                         <div className="supplier__grade grade SU">
                            //                                             <ScoreHistory item={item} />
                            //                                             <div
                            //                                                 className={`grade__value_wrapper ${classNameOfGrade(
                            //                                                     item.grade.key
                            //                                                 )}`}
                            //                                             >
                            //                                                 Grade {item.grade?.key}
                            //                                             </div>
                            //                                         </div>
                            //                                         <div className="grade__border"></div>
                            //                                         <div>
                            //                                             {item.status === 'rejected' && (
                            //                                                 <div className="task-complete__title-row">
                            //                                                     <div
                            //                                                         className="task-complete__decline-active"
                            //                                                         style={{ margin: '0 15px 0 0' }}
                            //                                                     >
                            //                                                         <img src={stopImage} />
                            //                                                         Rejected
                            //                                                     </div>
                            //                                                 </div>
                            //                                             )}
                            //                                             {item.status === 'shortlisted' && (
                            //                                                 <div className="task-complete__title-row">
                            //                                                     <div className="task-complete__approved-active">
                            //                                                         <img src={done} />
                            //                                                         Awarded
                            //                                                     </div>
                            //                                                 </div>
                            //                                             )}
                            //                                         </div>
                            //                                     </div>
                            //                                 </div>
                            //                                 {(item?.comments?.su_rejected_comment ||
                            //                                     item.comments?.su_rejected_category_name) && (
                            //                                     <div
                            //                                         className="task-complete__info-wrap"
                            //                                         style={{ width: '100%' }}
                            //                                     >
                            //                                         <div className="task-complete__wrap">
                            //                                             <div className="task-complete__name">
                            //                                                 Reason for Rejection
                            //                                             </div>
                            //                                         </div>
                            //                                         <div className="task-complete__wrap">
                            //                                             <div className="task-complete__value">
                            //                                                 {item.comments.su_rejected_comment
                            //                                                     ? item.comments.su_rejected_comment
                            //                                                     : item.comments
                            //                                                           ?.su_rejected_category_name}
                            //                                             </div>
                            //                                         </div>
                            //                                     </div>
                            //                                 )}

                            //                                 {openState.find((state) => state.id === item.id)?.open ? (
                            //                                     <div className="supplier-SU__additional">
                            //                                         <div className="supplier-SU__gray_row">
                            //                                             <div className="supplier-SU__item">
                            //                                                 <div className="supplier-SU__item-name">
                            //                                                     B-BBEE
                            //                                                 </div>
                            //                                                 <div className="supplier-SU__item-value">
                            //                                                     {item.b_bbee}
                            //                                                 </div>
                            //                                             </div>
                            //                                             <div className="supplier-SU__item">
                            //                                                 <div className="supplier-SU__item-name">
                            //                                                     Number of Employees
                            //                                                 </div>
                            //                                                 <div className="supplier-SU__item-value">
                            //                                                     {item.employees_number}
                            //                                                 </div>
                            //                                             </div>
                            //                                             <div className="supplier-SU__item last">
                            //                                                 <div className="supplier-SU__item-name">
                            //                                                     Annual Revenue
                            //                                                 </div>
                            //                                                 <div className="supplier-SU__item-value">
                            //                                                     {item.annual_revenue}
                            //                                                 </div>
                            //                                             </div>
                            //                                             <a
                            //                                                 href={item.website}
                            //                                                 target="_blank"
                            //                                                 rel="noreferrer"
                            //                                             >
                            //                                                 <div className="supplier-SU__white-btn">
                            //                                                     Visit Website <img src={Visit} />
                            //                                                 </div>
                            //                                             </a>
                            //                                         </div>
                            //                                         {item.conflict_of_interest && (
                            //                                             <div className="supplier-SU__add-text">
                            //                                                 <div className="supplier-SU__item-name">
                            //                                                     Potential conflict of interest
                            //                                                 </div>
                            //                                                 <div className="supplier-SU__conflict">
                            //                                                     <img src={messageIcon} />{' '}
                            //                                                     {item.conflict_of_interest}
                            //                                                 </div>
                            //                                             </div>
                            //                                         )}

                            //                                         <div className="supplier-SU__add-text">
                            //                                             {item.references.length > 0 && (
                            //                                                 <div className="supplier-SU__item-name">
                            //                                                     References:{' '}
                            //                                                 </div>
                            //                                             )}
                            //                                             <div className="supplier-SU__row-references">
                            //                                                 {item.references.map((ref) => {
                            //                                                     return (
                            //                                                         <div className="supplier-SU__reference reference">
                            //                                                             <div className="reference__item rating">
                            //                                                                 {ref.entity_name}
                            //                                                                 {ref?.rating && (
                            //                                                                     <div className="rating__item">
                            //                                                                         {star()}
                            //                                                                         {ref.rating}
                            //                                                                     </div>
                            //                                                                 )}
                            //                                                             </div>
                            //                                                             <div className="reference__name">
                            //                                                                 {ref.contact_name}
                            //                                                             </div>
                            //                                                             <div className="reference__email">
                            //                                                                 {ref.email}{' '}
                            //                                                                 {ref.phone_number}
                            //                                                             </div>
                            //                                                         </div>
                            //                                                     );
                            //                                                 })}
                            //                                             </div>
                            //                                         </div>

                            //                                         <div
                            //                                             className="supplier-SU__show"
                            //                                             style={{ borderBottom: 'none' }}
                            //                                             onClick={() => {
                            //                                                 const index = openState.findIndex(
                            //                                                     (state) => item.id === state.id
                            //                                                 );

                            //                                                 if (index !== -1) {
                            //                                                     const updatedStates = openState.map(
                            //                                                         (state, i) =>
                            //                                                             i === index
                            //                                                                 ? { ...state, open: false }
                            //                                                                 : state
                            //                                                     );
                            //                                                     setOpenState(updatedStates);
                            //                                                 }
                            //                                             }}
                            //                                         >
                            //                                             Hide Details{' '}
                            //                                             <img
                            //                                                 src={arrow}
                            //                                                 style={{ transform: 'rotate(180deg)' }}
                            //                                             />
                            //                                         </div>
                            //                                     </div>
                            //                                 ) : (
                            //                                     <div
                            //                                         className="supplier-SU__show"
                            //                                         style={{ borderBottom: 'none' }}
                            //                                         onClick={() => {
                            //                                             const index = openState.findIndex(
                            //                                                 (state) => item.id === state.id
                            //                                             );

                            //                                             if (index !== -1) {
                            //                                                 const updatedStates = openState.map(
                            //                                                     (state, i) =>
                            //                                                         i === index
                            //                                                             ? { ...state, open: true }
                            //                                                             : state
                            //                                                 );
                            //                                                 setOpenState(updatedStates);
                            //                                             }
                            //                                         }}
                            //                                     >
                            //                                         Show Details <img src={arrow} />
                            //                                     </div>
                            //                                 )}
                            //                             </div>
                            //                         </>
                            //                     );
                            //                 })}
                            //             </div>
                            //         </div>
                            //     );
                            // }
                        } else {
                            if (elem.status === 'pending_tr') {
                                return (
                                    <Evaluate4PendingTRSuppliersTaskComplete
                                        key={elem.id}
                                        ref={ref}
                                        taskName={elem?.name}
                                        suppliers={data.suppliers}
                                        statusImage={statusImage}
                                        setTaskId={setTaskId}
                                        setSupplierData={setSupplierData}
                                        setIsEditModal={setIsEditModal}
                                        onSpecifyPricing={(supplier) => {
                                            setSupplierForPriceInfo(supplier);
                                            setSupplierPriceInfoModalOpen(true);
                                        }}
                                    />
                                );
                            }
                            if (elem.status === 'pending_su') {
                                return (
                                    <Evaluate4PendingTRSuppliersTaskComplete
                                        key={elem.id}
                                        ref={ref}
                                        taskName={elem?.name}
                                        suppliers={data.suppliers}
                                        statusImage={statusImage}
                                        setTaskId={setTaskId}
                                        setSupplierData={setSupplierData}
                                        setIsEditModal={setIsEditModal}
                                        onSpecifyPricing={(supplier) => {
                                            setSupplierForPriceInfo(supplier);
                                            setSupplierPriceInfoModalOpen(true);
                                        }}
                                        status={'pending_su'}
                                    />
                                );
                            }
                            if (elem.status === 'completed') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete
                              `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={SupplierListIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__row-btns">
                                                <div
                                                    className="task__copyemails"
                                                    onClick={copyAllEmailsInTender}
                                                    style={{ margin: '0 15px 0 0' }}
                                                >
                                                    <img src={copyImage} />
                                                    Copy all Emails
                                                </div>
                                            </div>
                                        </div>

                                        {data.suppliers.map((elem) => {
                                            return (
                                                <SupplierCardForTR
                                                    elem={elem}
                                                    setIsEditModal={setIsEditModal}
                                                    setSupplierData={setSupplierData}
                                                    setTaskId={setTaskId}
                                                    isAward={true}
                                                />
                                            );
                                        })}
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'award_suppliers') {
                        if (elem.status === 'pending_tr' || elem.status === 'need_resend_tr') {
                            return (
                                <div
                                    key={elem.id}
                                    className={`tasks__task-complete task-complete${
                                        !data.suppliers?.length ? ' task-complete--empty-suppliers' : ''
                                    } ${data?.can_send_task ? 'green' : ''}`}
                                >
                                    <div className="task-complete__title">
                                        <div className="task-complete__title-row">
                                            <img src={SupplierListIcon} />
                                            {elem.name}
                                        </div>
                                        {elem.status === 'need_resend_tr' ? (
                                            <></>
                                        ) : (
                                            role !== 'super_admin' && (
                                                <img
                                                    src={plus}
                                                    className="task__plus"
                                                    onClick={() => {
                                                        setSupplierModal(true);
                                                    }}
                                                />
                                            )
                                        )}
                                    </div>
                                    {data.suppliers.map((item) => {
                                        return (
                                            <div className="task-complete__supplier supplier ">
                                                <div className="supplier__header newdesign">
                                                    <div className="supplier-tags">
                                                        <div className="supplier-tags__left">
                                                            {item.added_by_bayer && (
                                                                <span className="tag tag--buyer">Added by buyer</span>
                                                            )}

                                                            {item.incumbent && (
                                                                <span className="tag tag--incumbent">
                                                                    Incumbent Supplier
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {item.status === 'shortlisted' && (
                                                        <div className="supplier-tags__status">Awarded by Buyer</div>
                                                    )}{' '}
                                                    {/* {elem.status === 'rejected' && (
                                                                <div className="supplier-tags__status rejected">
                                                                    Rejected
                                                                </div>
                                                            )} */}
                                                </div>
                                                <div className="supplier__row">
                                                    <div className="supplier__wrap first">
                                                        <div className="supplier__title">
                                                            ({item.name_prefix}) {item.name}
                                                        </div>
                                                        <div className="supplier__subtitle">{item.trading_name}</div>
                                                    </div>
                                                    {item.manager_name ? (
                                                        <div className="supplier__wrap">
                                                            <div className="supplier__title">
                                                                {item.manager_name ? item.manager_name : ''}
                                                            </div>
                                                            <div className="supplier__subtitle">
                                                                {item?.email ? item?.email : ''}{' '}
                                                                {item?.phone_number ? item?.phone_number : ''}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="supplier__wrap"></div>
                                                    )}

                                                    {elem.status === 'need_resend_tr' ? (
                                                        <></>
                                                    ) : (
                                                        role !== 'super_admin' && (
                                                            <img
                                                                src={deleteIcon}
                                                                className="supplier__delete"
                                                                onClick={() => {
                                                                    setTaskId(elem.id);
                                                                    setSupplierData(item);
                                                                    setIsDeleteModal(true);
                                                                }}
                                                            />
                                                        )
                                                    )}
                                                </div>

                                                {role !== 'super_admin' &&
                                                    (item?.payload?.supply_agreement ? (
                                                        <div className="supplier-SU__supplier_aggrement_wrapper">
                                                            {elem.status === 'need_resend_tr' && (
                                                                <div className="supplier-SU__resend_link_wrapper">
                                                                    <a
                                                                        href={item?.payload?.supply_agreement}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div className="supplier-SU__white-btn">
                                                                            Supplier Agreement <img src={Visit} />
                                                                        </div>
                                                                    </a>
                                                                    <div
                                                                        className="supplier-SU__white-btn"
                                                                        onClick={() => {
                                                                            setTaskId(elem.id);
                                                                            setSupplierData(item);
                                                                            setIsAgreementLinkModal(true);
                                                                        }}
                                                                    >
                                                                        Resend Link{' '}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {elem.status !== 'need_resend_tr' && (
                                                                <>
                                                                    <a
                                                                        href={item?.payload?.supply_agreement}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <div className="supplier-SU__white-btn">
                                                                            Supplier Agreement <img src={Visit} />
                                                                        </div>
                                                                    </a>

                                                                    <img
                                                                        src={editIcon}
                                                                        className="supplier__delete"
                                                                        style={{ margin: '0 0 0 10px' }}
                                                                        onClick={() => {
                                                                            setTaskId(elem.id);
                                                                            setSupplierData(item);
                                                                            setIsAgreementLinkModal(true);
                                                                        }}
                                                                    />
                                                                </>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <Button
                                                            type="primary"
                                                            className="blue-btn supplier-SU__supply-agreement-link-btn"
                                                            onClick={() => {
                                                                setTaskId(elem.id);
                                                                setSupplierData(item);
                                                                setIsAgreementLinkModal(true);
                                                            }}
                                                        >
                                                            Supply Agreement Link
                                                        </Button>
                                                    ))}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        }
                    }
                    if (elem.action === 'design_registered_suppliers') {
                        if (elem.status === 'completed') {
                            return (
                                <div key={elem.id} className={`tasks__task task `}>
                                    <div className="task__title task__title--with-supplier-count">
                                        <div className="task__title-main">
                                            <div className="task__title-leading">
                                                <div className="task__title-activity-pill">
                                                    <img src={userProfileTaskIcon} alt="" />
                                                </div>
                                                <span className="task__title-text">{elem.name}</span>
                                            </div>
                                            <span className="task__supplier-count-badge" aria-label="Supplier count">
                                                {data?.invited_suppliers?.completed_registration}
                                            </span>
                                            <Tooltip title="The suppliers who’ve confirmed their interest in this service opportunity and will be included in the evaluation process.">
                                                <span className="task__title-info-trigger" role="button" tabIndex={0}>
                                                    <img src={i} alt="" className="task__title-info-icon" />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </div>

                                    <div className="task-complete__btn" onClick={() => setOpenSuppList(true)}>
                                        View Supplier List
                                    </div>
                                </div>
                            );
                        }
                    }
                })}

            <SupplierPriceInformationModal
                tenderId={data.id}
                openModal={supplierPriceInfoModalOpen}
                setOpenModal={setSupplierPriceInfoModalOpen}
                supplier={supplierForPriceInfo}
                messageApi={messageApi}
                setTrigger={setTrigger}
            />

            {supplierModal && (
                <AddSuppliersModal
                    openModal={supplierModal}
                    setOpenModal={setSupplierModal}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    data={data}
                />
            )}
            {isEditModal && (
                <EditSupplierModal
                    openModal={isEditModal}
                    setOpenModal={setIsEditModal}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    SupplierData={SupplierData}
                    data={data}
                />
            )}

            {editCandidateSupplier && (
                <AddSupplierModal
                    openModal={openEditCandidateModal}
                    setOpenModal={setOpenEditCandidateModal}
                    setOpenAddSuppInfoModal={setAddSuppInfoModalStub}
                    setTrigger={setTrigger}
                    SupplierData={editCandidateSupplier}
                    data={data}
                    onAfterClose={() => setEditCandidateSupplier(null)}
                />
            )}

            {isDeleteModal && (
                <Modal
                    className="confirmModal"
                    centered
                    open={isDeleteModal}
                    width={660}
                    closeIcon={<></>}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyItems: 'space-between',
                                gap: '16px',
                                width: '100%',
                                margin: '25px 0 0 0'
                            }}
                        >
                            <Button key="back" onClick={() => setIsDeleteModal(false)} block className="cancel">
                                Cancel
                            </Button>
                            <button className="quit" style={{ width: '100%' }} onClick={deleteSupplierFunc}>
                                {isLoadingDelete || isLoadingDeleteInvite || isLoadingDeleteAward ? (
                                    <Loader />
                                ) : (
                                    'Delete'
                                )}
                            </button>
                        </div>
                    }
                >
                    <div className="modal-confirm">
                        <div className="modal-confirm__title">Remove supplier from the Matchmaking Journey?</div>
                        <div className="modal-confirm__subtitle" style={{ color: '#4D5E93' }}>
                            Are you sure you want to remove the <b>{SupplierData?.name}</b> from the Matchmaking Journey
                            supplier list?{' '}
                        </div>
                    </div>
                </Modal>
            )}
            {isCreateSupplierModal && (
                <AddConfirmedSuppliersModal
                    openModal={isCreateSupplierModal}
                    setOpenModal={setIsCreateSupplierModal}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    data={data}
                />
            )}
            {isRejectModal && (
                <RejectSupplierModal
                    openModal={isRejectModal}
                    setOpenModal={setIsRejectModal}
                    setTrigger={setTrigger}
                    selectedSupplier={selectedSupplier}
                    data={data}
                    taskId={taskId}
                    messageApi={messageApi}
                />
            )}
            {isRejectIncumbentModal && (
                <RejectIncumbentSupplier
                    openModal={isRejectIncumbentModal}
                    setOpenModal={setIsRejectIncumbentModal}
                    setTrigger={setTrigger}
                    selectedSupplier={selectedSupplier}
                    data={data}
                    taskId={taskId}
                    setIsRejectModal={() => {
                        if (data?.phase === 'evaluate_3' || data?.phase === 'evaluate_4') {
                            setIsRejectSupplierModal(true);
                        } else {
                            setIsRejectModal(true);
                        }
                    }}
                />
            )}
            {isSuppAwardModal && (
                <AwardSuppliserModal
                    openModal={isSuppAwardModal}
                    setOpenModal={setIsSuppAwardModal}
                    data={data}
                    taskId={taskId}
                    messageApi={messageApi}
                    setTrigger={setTrigger}
                    selectedSupplier={selectedSupplier}
                    specialFormats={['doc', 'docx', 'pdf']}
                />
            )}
            {isAgreementLinkModal && (
                <AgreementLinkModal
                    openModal={isAgreementLinkModal}
                    setOpenModal={setIsAgreementLinkModal}
                    setTrigger={setTrigger}
                    SupplierData={SupplierData}
                    data={data}
                    isResend={
                        data?.phase_tasks?.find((elem) => elem.action === 'award_suppliers')?.status ===
                        'need_resend_tr'
                    }
                />
            )}
            {openSuppList && (
                <ViewSupplierListModal openModal={openSuppList} setOpenModal={setOpenSuppList} data={data} />
            )}
            {!!incumbentSupp && (
                <IncumbentModal
                    supplier={incumbentSupp}
                    openModal={!!incumbentSupp}
                    setOpenModal={setIncumbentSupp}
                    tenderData={data}
                    setTrigger={setTrigger}
                />
            )}
            {isRejectSupplierModal && (
                <RejectSupplierModalOnEvaluate2
                    openModal={isRejectSupplierModal}
                    setOpenModal={setIsRejectSupplierModal}
                    setTrigger={setTrigger}
                    selectedSupplier={selectedSupplier}
                    data={data}
                />
            )}
        </>
    );
};
